import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSuggestions(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/suggestion', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchSuggestion(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/suggestion/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        confirmSuggestion(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/suggestion/${id}/confirm`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        ignoreSuggestion(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/suggestion/${id}/ignore`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteSuggestion(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/suggestion/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
